import React from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { setExtra } from 'apps/auth/actions/extraAction';
import { setNewFields } from 'apps/auth/actions/formAction';
import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { getEmptyMandatoryOrFieldsWithError } from 'apps/auth/components/form-multi/utils';
import { AMOUNT_FROM, AMOUNT_TO, AMOUNT_TO_CCY } from 'apps/auth/constants/fieldsName';
import { GA_EXCHANGE_FORM_NAME } from 'apps/auth/constants/formName';
import { apiFetchData, changeBrowserUrlWithOutReload } from 'apps/auth/helpers/api';
import update from 'apps/auth/helpers/Immutability';

const GaArrows = (props) => {
    const toPocket = props.availableAccountsTo?.find((c) => c.pocketCurrency.ncode === props.amountToCcy);
    const isZeroAmount = !props.amountFrom.value || !props.amountTo.value;
    const hasNoErrors = getEmptyMandatoryOrFieldsWithError([props.amountFrom, props.amountTo]).length === 0;
    const shouldDisplayArrows = toPocket?.id && toPocket.balance > 0 && isZeroAmount && hasNoErrors;

    const click = (e) => {
        e.preventDefault();
        props.toggleSpinner(true);
        props.fields[AMOUNT_TO_CCY] = update(props.fields[AMOUNT_TO_CCY], { value: { $set: props.pocket.pocketCurrency.ncode } });

        props.toggleSpinner(true);
        const url = `/auth/ga/pocket/${toPocket.id}/exchange`;
        apiFetchData(url + `?&isFrom=${!props.isFrom}`, props.fields)
            .then((json) => {
                changeBrowserUrlWithOutReload(url, json);
                if (json) {
                    const extra = json?.extra;
                    if (json?.extra) {
                        props.setExtra(extra);
                    }
                    const fields = json?.form?.fields;
                    if (fields) {
                        props.setNewFields(GA_EXCHANGE_FORM_NAME, fields);
                    }
                }
            })
            .finally(() => {
                props.toggleSpinner(false);
            });
    };

    return (
        <>
            {shouldDisplayArrows && (
                <DiskButton
                    size="small"
                    iconName="arrows-right-left"
                    iconColor="secondary"
                    type="button"
                    raised={false}
                    onClick={(e) => {
                        click(e);
                    }}
                />
            )}
        </>
    );
};
const mapStateToProps = (state) => ({
    pocket: state.extra.pocket,
    fields: state.form[GA_EXCHANGE_FORM_NAME]?.fields,
    amountFrom: state.form[GA_EXCHANGE_FORM_NAME]?.fields[AMOUNT_FROM],
    amountTo: state.form[GA_EXCHANGE_FORM_NAME]?.fields[AMOUNT_TO],
    amountToCcy: state.form[GA_EXCHANGE_FORM_NAME].fields[AMOUNT_TO_CCY].value,
    availableAccountsTo: state.extra.availableAccountsTo,
});
export default connect(mapStateToProps, { toggleSpinner, setExtra, setNewFields })(GaArrows);
